import { toItem } from '../mappers/item';
import { partial } from '../../../utils/utils';
export function parseItems(settings, res) {
  let cursor = null;
  let size = null;
  if (res.data.paging && res.data.paging.next) {
    cursor = Number(res.data.paging.next.match(/&page=(\d+)/i)[1]);
    size = res.data.per_page;
  }
  res.data = (res.data.data || []).filter(function (item) {
    return item && item.embed && item.embed.html;
  }).map(partial(toItem, settings));
  res.paging = {
    cursor,
    size
  };
  return res;
}